import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';
import image from '../../../assets/ChatGPT Image Aug 24, 2026, 02_00_10 PM.png';

const MediaEditorIndustry = () => {
  return (
    <IndustryPageTemplate
      title="Own Media Editor"
      subtitle="Professional Editing in Your Browser"
      desc="Edit your videos, audio and images with powerful editing tools. A complete, non-linear editing suite available directly in your browser with cloud-sync."
      image={image}
      themeColor="#ff9800"
      bgGradient="linear-gradient(135deg, rgba(255,152,0,0.15), rgba(255,255,255,0))"
      features={[
  {
    "title": "Video Editing",
    "desc": "Cut, splice, and render 4K video seamlessly without downloading software."
  },
  {
    "title": "Audio Editing",
    "desc": "Mix tracks, apply EQ, and master your audio with professional plugins."
  },
  {
    "title": "Image Editing",
    "desc": "Retouch photos and create stunning thumbnails natively."
  },
  {
    "title": "Multi-track Timeline",
    "desc": "Organize complex projects with unlimited video and audio tracks."
  }
]}
    />
  );
};

export default MediaEditorIndustry;
